import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { postXIntegration } from 'services/integrationService';
import { useSelector } from 'react-redux';

const XCallback = () => {
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  const { current_subscription: currentSubscription } =
    user?.subscriptions ?? {};

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const oauthToken = queryParams.get('oauth_token');
    const oauthVerifier = queryParams.get('oauth_verifier');
    if (oauthToken && oauthVerifier) {
      postXIntegration({
        oauth_verifier: oauthVerifier,
        oauth_token: oauthToken,
      })
        .then((data) => {
          if (window.opener) {
            window.opener.postMessage({ type: 'X_SUCCESS', payload: {} }, '*');
          }
          window.close();
        })
        .catch((error) => {
          console.error('Error fetching X token:', error);
          // Send error back to parent window
          if (window.opener) {
            const errorData = error?.response?.data || {};
            window.opener.postMessage(
              {
                type: 'X_ERROR',
                payload: {
                  message: errorData.error || errorData.message || 'Failed to connect X account',
                  link: errorData.link || '',
                  showModal: errorData.showModal || false,
                },
              },
              '*',
            );
          }
          // Close the popup
          window.close();
        });
    }
  }, [location, currentSubscription]);

  return <div>Processing X Login...</div>;
};

export default XCallback;
